import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ProductValueQueryService {
  private readonly apiUrl = environment.API_URL + 'internal/';

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService
  ) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.tokenService.getComponentCodeToken(),
      'Accept-Language': 'pt-BR'
    });
  }

  public getProductPrice(productCode: number | string, branchCode: number): Observable<any> {
    const params = new HttpParams()
      .set('ProductCode', String(productCode))
      .set('BranchCode', String(branchCode));
    return this.httpClient.get<any>(
      `${this.apiUrl}product/v2/product-prices`,
      { headers: this.getHeaders(), params }
    );
  }

  public getProductImages(productCodeList: number[]): Observable<any> {
    const body = {
      filter: { productCodeList },
      option: { quantityImageResult: 1 },
      page: 1,
      pageSize: 10
    };
    return this.httpClient.post<any>(
      `${this.apiUrl}image/v2/product/search`,
      body,
      { headers: this.getHeaders() }
    );
  }
}
